import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.prototype.$http = axios

Vue.use(Vuex)

const state = {
  // Bucket列表
  bucketdata: [],
  // Bucket路径
  filepath: [],
  // Bucket子路径
  pathsubdata: [],
  // Bucket名称
  bn: '',
  // Path名称
  pathname: '',
  // 文件路径树数据,
  spathdata: []
}

const mutations = {
  setbucketdata (state, res) {
    // 设置Bucket列表
    state.bucketdata = res
  },
  setfilepath (state, res) {
    // 设置pathdata
    state.filepath = res
  },
  setsubpathdata (state, res) {
    // 设置pathdata
    state.pathsubdata = res
  },
  setbucketname (state, payload) {
    // 设置Bucket名称
    state.bn = payload.bucketname
  },
  setpathname (state, payload) {
    // 设置Path名称
    state.pathname = payload.pathname
  },
  setspathdata (state, payload) {
    // 设置Path名称
    state.spathdata = payload.spathdata
  },
  setspathnode (state, payload) {
    // 设置Path名称
    state.spathnode = payload.spathnode
  },
  setspathchild (state, res) {
    state.spathdata.Children = res
  }
}

const getters = {
  buckets: (state) => {
    return getters.state.bucketdata
  }
}

const actions = {
  // 获取Bucket列表
  getbuckets ({ commit, state }) {
    axios({
      url: 'http://39.97.234.201:9096/listbucket',
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log(res)
        if (res.data.success) {
          var bmlist = JSON.parse(res.data.data)
          var bmdata = []
          for (var j = 0; j < bmlist.length; j++) {
            var stmp = bmlist[j]
            let datatmp = {
              bucketname: stmp
            }
            bmdata.push(datatmp)
          }
          commit('setbucketdata', bmdata)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 获取路径
  getbpac ({ commit, state }) {
    axios({
      url: 'http://39.97.234.201:9096/listpath',
      method: 'post',
      data: {
        bucketname: state.bn
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log(res)
        if (res.data.success) {
          var treedatas = []
          var arrdatas = JSON.parse(res.data.data)
          for (var i = 0; i < arrdatas.length; i++) {
            console.log(arrdatas[i])
            var treedata
            treedata = {
              path: arrdatas[i],
              Children: []
            }
            treedatas.push(treedata)
          }
          commit('setfilepath', treedatas)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 获取子路径
  getsubbpac ({ commit, state }) {
    axios({
      url: 'http://39.97.234.201:9096/listpath',
      method: 'post',
      data: {
        bucketname: state.bn,
        bucketpath: {String: state.pathname, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log('获取路径')
        console.log(res)
        if (res.data.success) {
          var treedatas = []
          var arrdatas = JSON.parse(res.data.data)
          for (var i = 0; i < arrdatas.length; i++) {
            console.log(arrdatas[i])
            var treedata
            treedata = {
              path: arrdatas[i],
              Children: []
            }
            treedatas.push(treedata)
          }
          commit('setspathchild', treedatas)
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 添加新路径
  addnewpath ({ commit, state }) {
    axios({
      url: 'http://39.97.234.201:9096/createbucketpath',
      method: 'post',
      data: {
        bucketname: state.bn,
        bucketpath: {String: state.pathname, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log(res)
        if (res.data.success) {
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  },
  // 删除路径
  delnewpath ({ commit, state }) {
    axios({
      url: 'http://39.97.234.201:9096/listcurpath',
      method: 'post',
      data: {
        bucketname: state.bn,
        bucketpath: {String: state.pathname, Valid: true}
      },
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(function (res) {
        console.log(res)
        if (res.data.success) {
          var alldatas = [state.pathname]
          var arrdatas = JSON.parse(res.data.data)
          console.log('子路径数据')
          console.log(arrdatas)
          if (arrdatas) {
            for (var i = 0; i < arrdatas.length; i++) {
              alldatas.push(arrdatas[i])
            }
          }
          console.log('路径内文件夹:')
          console.log(alldatas)
          var delpaths = {
            bucketname: state.bn,
            bucketpaths: alldatas
          }
          axios({
            url: 'http://39.97.234.201:9096/delpaths',
            method: 'post',
            data: delpaths,
            headers: {
              'Content-Type': 'application/json'
            }
          })
            .then(function (res) {
              console.log(res)
              if (res.data.success) {
              }
            })
            .catch(function (error) {
              console.log('error' + error)
            })
        }
      })
      .catch(function (error) {
        console.log('error' + error)
      })
  }
}

export default ({
  namespaced: true,
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/modules/oss.js